import { FC } from 'react';

const IllustrationClosed: FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="49"
    height="65"
    fill="none"
    viewBox="0 0 49 65"
  >
    <path
      fill="#323232"
      d="M42.667 21.833h-3.048v-6.095C39.619 7.327 32.792.5 24.381.5S9.143 7.327 9.143 15.738v6.095H6.095C2.743 21.833 0 24.576 0 27.93v30.476C0 61.757 2.743 64.5 6.095 64.5h36.572c3.352 0 6.095-2.743 6.095-6.095V27.929c0-3.353-2.743-6.096-6.095-6.096m-27.429-6.095a9.13 9.13 0 0 1 9.143-9.143 9.13 9.13 0 0 1 9.143 9.143v6.095H15.238zm27.429 42.667H6.095V27.929h36.572zM24.38 49.262c3.352 0 6.095-2.743 6.095-6.095 0-3.353-2.743-6.096-6.095-6.096s-6.095 2.743-6.095 6.096c0 3.352 2.743 6.095 6.095 6.095"
    ></path>
  </svg>
);

export default IllustrationClosed;
